const theme = {
	space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
	colors: {
		primary: '#bd5f28',
		primaryDark: '#e4996e',
		primaryTextColor: '#222',
		lightestGray: '#868686',
		darkGray: '#EBEBEB',
		lightGray: '#F3F3F3',
		borderGray: '#DEDEDE',
		neonGreen: '#409F11',
		red: '#F62E2D',
		white: '#fff',
		royalBlue: '#1925B7',
		teal: '#069D88'
	},
	linkCardSize: {
		iconSize: {
			med: '20px',
			lg: '40px'
		}
	}
}

export default theme
